<template>
  <div v-if="formData && formData.productType" :class="`donation-form donation-form--${formData.productType.replace('commerce_product--', '').replaceAll('_', '-')}`">
    <FormKit
      type="form"
      :submit-label="formData.submitLabel"
      @submit="addProductToCart()"
      :disabled="blockAddToCartButton"
      :validation-messages="{
        incomplete: 'Nie wszystkie pola zostały wypełnione poprawnie1',
      }"
    >
      <template v-if="formData.productType !== 'commerce_product--philanthropist' && formData.paymentTypes.length === 1 && formData.paymentTypes[0] === 'single'">
        <h3>Darowizna jednorazowa</h3>
      </template>
      <template v-else-if="formData.productType !== 'commerce_product--philanthropist' && formData.productType !== 'commerce_product--ad_hoc_campaign' && formData.paymentTypes.length === 1 && formData.paymentTypes[0] === 'monthly'">
        <h3>Darowizna cykliczna</h3>
      </template>
      <template v-else-if="formData.productType === 'commerce_product--ad_hoc_campaign' && formData.paymentTypes.length === 1 && formData.paymentTypes[0] === 'monthly'">
        <h3>Darowizna miesięczna</h3>
      </template>
      <template v-else-if="formData.productType === 'commerce_product--philanthropist'">
        <h3>Wesprzyj i zostań filantropem</h3>
      </template>
      <template v-else-if="formData.paymentTypes.length === 2">
        <div class="donation-form__payment-type" :class="`donation-form__payment-type--${formData.productType.replace('commerce_product--', '').replaceAll('_', '-')}`">
          <formKit
            type = 'radio'
            name = 'paymentType'
            label = 'Wybierz formę darowizny'
            v-model = "formData.paymentType"
            :options = "[
              { value: 'monthly', label: 'co miesiąc' },
              { value: 'single', label: 'jednorazowo'}
            ]"
          ></formKit>
        </div>
      </template>
      <template v-if="formData.paymentType === 'single'">
        <div class="donation-form__payment" :class="`donation-form__payment--${formData.productType.replace('commerce_product--', '').replaceAll('_', '-')}`">
          <formKit
            type = 'radio'
            name = 'single'
            label = 'Wybierz kwotę darowizny'
            v-model = "formData.single"
            validation-visibility="submit"
            validation="require_one:singleCustom"
            :validation-messages="{
              require_one: '',
            }"
            :options = "formData.prices_single"
          ></formKit>
          <formKit
            outer-class = 'own-amount'
            type = 'number'
            name = 'singleCustom'
            v-model = "formData.singleCustom"
            :validation="validationSingleMinimal"
            validation-visibility="submit"
            :validation-messages="validationMessages"
            placeholder = 'wpisz własną kwotę'
          ></formKit>
        </div>
      </template>
      <template v-if="formData.paymentType === 'monthly'">
        <div class="donation-form__payment" :class = "`donation-form__payment--${formData.productType.replace('commerce_product--', '').replaceAll('_', '-')}`">
          <formKit
            type = 'radio'
            name = 'monthly'
            id = 'paymentType'
            label = 'Wybierz kwotę darowizny'
            validation="require_one:monthlyCustom"
            validation-visibility="submit"
            :validation-messages="{
              require_one: '&nbsp;'
            }"
            v-model = "formData.monthly"
            :options = "formData.prices_monthly"
          ></formKit>
          <formKit
            outer-class = 'own-amount'
            type = 'number'
            name = 'monthlyCustom'
            v-model = "formData.monthlyCustom"
            :validation = "validationMonthlyMinimal"
            validation-visibility="submit"
            :validation-messages="validationMessages"
            placeholder = 'wpisz własną kwotę'
          ></formKit>
        </div>
      </template>
      <template v-if="formData.giftable">
        <div class="donation-form__gift" :class = "`donation-form__gift--${formData.productType.replace('commerce_product--', '').replaceAll('_', '-')}`">
          <formKit
            :disabled = "currentPrice < minCertificatePrice"
            type = 'checkbox'
            name = 'gift'
            label = 'Na prezent'
            v-model = "formData.gift"
          ></formKit>
          <template v-if="currentPrice < minCertificatePrice && formData.gift">
            <p>Minimalna kwota adopcji na prezent to {{ minCertificatePrice }} zł</p>
          </template>
        </div>
      </template>
      <template v-if="globalInformation.field_safe_payments_info?.value">
        <div class="donation-form__safe-payments">
          <p>{{ globalInformation.field_safe_payments_info.value }}</p>
        </div>
      </template>
    </FormKit>
  </div>
</template>

<script setup>
import { inject } from 'vue';

const formData = inject('donationFormData');
const minCertificatePrice = inject('minCertificatePrice');
const currentPrice = inject('currentPrice');
const addProductToCart = inject('addProductToCart');
const validationSingleMinimal = inject('validationSingleMinimal');
const validationMonthlyMinimal = inject('validationMonthlyMinimal');
const validationMessages = inject('validationMessages');
const globalInformation = inject('globalInformation');
const blockAddToCartButton = inject('blockAddToCartButton');
</script>
